const modularKitchenInstallerService = {
  title: "Modular Kitchen Installer",
  icon: "🍽️",
  shortDescription:
    "Kitchen fitting, cabinet installation, accessory fitting, and modular unit adjustments.",
  longDescription:
    "Book modular kitchen support for installation, corrections, hinge/channel fixes, and section-level alignment tasks.",
  consultationNote:
    "Complete modular kitchen execution and new layout work should begin with inspection.",
  responsePromise:
    "Assignment depends on kitchen scope, sections involved, and fitter expertise.",
  warrantyPolicy:
    "Support depends on fitting integrity, existing hardware, and job scope.",
  subServices: [
    {
      id: "kitchen-cabinet-install",
      title: "Cabinet Section Installation",
      icon: "🗄️",
      group: "Cabinets",
      description:
        "Install or secure modular cabinet section with alignment support.",
      basePrice: 999,
      priceType: "starts_at",
      duration: "2-4 hrs",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "kitchen-hinge-channel-fix",
      title: "Hinge / Channel Fix",
      icon: "🪛",
      group: "Repair",
      description:
        "Fix hinge, shutter, channel, or alignment issue in modular kitchen units.",
      basePrice: 499,
      priceType: "fixed",
      duration: "30-60 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "kitchen-accessory-fitting",
      title: "Accessory Fitting",
      icon: "🧰",
      group: "Accessories",
      description:
        "Fit baskets, organizers, handles, or kitchen utility accessories.",
      basePrice: 599,
      priceType: "starts_at",
      duration: "45-90 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "kitchen-inspection",
      title: "Modular Kitchen Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection for kitchen layout support, correction planning, or execution estimate.",
      basePrice: 399,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default modularKitchenInstallerService;